/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { PageGridContainer, breakpoints } from '@coursera/cds-core';

const styles = {
  section: css`
    padding: var(--cds-spacing-600) 0;

    ${breakpoints.down('xs')} {
      padding: var(--cds-spacing-300) 0;
    }
  `,
  container: css`
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    padding: 0 var(--cds-spacing-200);
    gap: var(--cds-spacing-150);

    ${breakpoints.down('xs')} {
      flex-direction: column;
      gap: var(--cds-spacing-100);
      width: 100%;
    }
  `,
};

type Props = {
  children: React.ReactNode[];
};

const BucketModule = ({ children }: Props) => {
  return (
    <section css={styles.section}>
      <PageGridContainer>
        <div css={styles.container}>{children}</div>
      </PageGridContainer>
    </section>
  );
};

export default BucketModule;
